import { Connection } from '@xyflow/react';
import { EdgeId, EdgeModel } from './edge.model';
import { v4 as uuidv4 } from 'uuid';

export const edgeFactory = (
  snapToGrid: boolean,
  connection: Connection,
  label?: string,
  edgeId?: EdgeId
): EdgeModel | null => {
  if (!connection.source || !connection.target) {
    return null;
  }
  return {
    id: edgeId || (uuidv4() as EdgeId),
    ...connection,
    type: snapToGrid ? 'insertSmooth' : 'insert',
    reconnectable: true,
    data: {
      label: label || '',
    },
  };
};
